export const ResultNoticeType = {
    OJS: "OJS",
    ATTACHMENT: "ATTACHMENT",
    BZP: "BZP"
}
export default ResultNoticeType;